import { render, staticRenderFns } from "./TeamDataModal.vue?vue&type=template&id=5348c318&"
import script from "./TeamDataModal.vue?vue&type=script&lang=js&"
export * from "./TeamDataModal.vue?vue&type=script&lang=js&"
import style0 from "./TeamDataModal.vue?vue&type=style&index=0&id=5348c318&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports